<template>
  <div class="white-wrapper">
    <div class="row mt-3 pb-2">
      <div class="col-12 col-sm-5 text-center d-flex align-items-center justify-content-center">
        <moon-image
            :quarter="moonInfo['quarter']"
            :phase="moonInfo['phase']"
        />
      </div>
      <div class="col-12 col-sm-7">
        <div class="moon-day-intro">
          <h1 class="today">{{ today }}</h1>
          <h2 class="moon-days">{{ moonInfo["day_name"] }}</h2>
          <p>({{ moonInfo["phase"].trim() }})</p>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="moonrise align-items-end d-flex flex-column">
              <div class="moon__time-wrapper">
                <img src="../../assets/icons/moonrise.png" class="moon-icon"/>
                <span>{{ moonInfo["moonrise"].trim() }}</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="moonset align-items-start d-flex flex-column">
              <div class="moon__time-wrapper">
                <img src="../../assets/icons/moonset.png" class="moon-icon"/>
                <span>{{ moonInfo["moonset"].trim() }}</span>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="text-center mt-3">
              <moon-sign :signs="moonInfo['signs']"/>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MoonImage from "@/components/MoonDaySummary/MoonImage";
import MoonSign from "@/components/MoonDaySummary/MoonSign";

import {today} from "@/lib/utils";
import {store} from "@/store";
import client from "@/services/client";


export default {
  name: "MoonDayInfo",
  components: {MoonSign, MoonImage},
  data() {
    return {
      todayMoonDayInfo: {},
    }
  },
  computed: {
    today() {
      return today();
    },
    moonInfo() {
      return store.state.moonDayInfo;
    },
    isMobile() {
      return client.isMobile();
    }
  }
}
</script>

<style lang="scss" scoped>
.moon-day-intro {
  text-align: center;

  & .today {
    font-weight: 600;
    font-size: 32px;
    margin: 0;
  }

  & .moon-days {
    font-weight: 500;
    font-size: 20px;
    margin-top: 7px;
    margin-bottom: 0;
  }
}

.moon__time-wrapper {
  display: block;
  text-align: center;
}

.moon-icon {
  display: block;
  margin: 0 auto;
  width: 32px;
  height: auto;
}
</style>